document.addEventListener('DOMContentLoaded', () => {
  const ratingWrapper = document.querySelector('.pdp-info__rating');
  const stampedContainer = document.querySelector('.stamped-product-reviews-badge');

  if (!ratingWrapper || !stampedContainer) return;

  const updateRating = () => {
    const badge = stampedContainer.querySelector('.stamped-badge');
    const caption = stampedContainer.querySelector('.stamped-badge-caption');

    if (!badge || !caption) return false;

    const rating = badge.dataset.rating;
    const reviews = caption.dataset.reviews;

    if (!reviews || Number(reviews) === 0) {
      ratingWrapper.style.display = 'none';
      return true;
    }

    ratingWrapper.querySelector('.pdp-info__rating-value').textContent = rating;
    ratingWrapper.querySelector('.pdp-info__rating-count').textContent = `(${reviews})`;

    ratingWrapper.style.display = '';

    return true;
  };

  if (updateRating()) return;

  const observer = new MutationObserver(() => {
    if (updateRating()) {
      observer.disconnect();
    }
  });

  observer.observe(stampedContainer, {
    childList: true,
    subtree: true,
  });
});